// v2: v1 was set permanently by an accidental backdrop tap (now a soft-close);
// bumping the version re-surfaces the prompt for anyone wrongly dismissed.
export const INSTALL_COACH_DISMISS_KEY = "autumn_install_coach_dismissed_v2";

// Show the install prompt on the login screen AND inside the app — hide it only
// on onboarding / registration / legal flows (where a modal prompt is unwelcome).
const HIDDEN_ROUTE_PREFIXES = [
  "/forgot-password",
  "/reset-password",
  "/register",
  "/register-marketing",
  "/privacy",
  "/terms",
  "/onboarding",
];

export function isInstallRoute(pathname: string): boolean {
  return !HIDDEN_ROUTE_PREFIXES.some((p) => pathname.startsWith(p));
}

// Parse the iOS version from the UA's "CPU iPhone OS 16_4" / "CPU OS 16_4" token.
function iosAtLeast(userAgent: string, major: number, minor: number): boolean {
  const m = /OS (\d+)_(\d+)/.exec(userAgent);
  if (!m) return false;
  const [maj, min] = [Number(m[1]), Number(m[2])];
  return maj > major || (maj === major && min >= minor);
}

// iOS only: all iOS browsers are WebKit and none fire `beforeinstallprompt`, so
// the coach shows manual Share → "Add to Home Screen" steps. Safari exposes that
// path on any version; Chrome (CriOS) and Edge (EdgiOS) only gained it in iOS
// 16.4, so gate them on that. Firefox (FxiOS) and Opera (OPiOS) never had it.
export function isIosInstallCapable(userAgent: string): boolean {
  if (!/iP(hone|ad|od)/.test(userAgent)) return false;
  if (/(FxiOS|OPiOS)/.test(userAgent)) return false;
  const isThirdParty = /(CriOS|EdgiOS)/.test(userAgent);
  if (isThirdParty && !iosAtLeast(userAgent, 16, 4)) return false;
  return true;
}

export interface InstallCoachEnv {
  userAgent: string;
  standalone: boolean;
  pathname: string;
  dismissed: boolean;
}

export function shouldShowInstallCoach(env: InstallCoachEnv): boolean {
  if (!isIosInstallCapable(env.userAgent)) return false;
  if (env.standalone) return false;
  if (env.dismissed) return false;
  return isInstallRoute(env.pathname);
}
